import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ScheduleOutageDelete, ScheduleOutageNew, ScheduleOutageResponse, ScheduleOutageUpdate } from '../../../model/admin/schedule-outage.model';
import { Observable } from 'rxjs';
import { ADMIN_SERVICE } from '../../service-url';
import { skipSpinnerOptions } from '../../../v2/core/services/http-options.utils';

@Injectable({
  providedIn: 'root'
})
export class ScheduleOutageService {

  constructor(private http:HttpClient) { }

  public getScheduleOutage(): Observable<ScheduleOutageResponse> {
      return this.http.get<ScheduleOutageResponse>(ADMIN_SERVICE.schedule_outage, skipSpinnerOptions());
  }

  public getScheduleOutageList(): Observable<ScheduleOutageResponse[]> {
      return this.http.get<ScheduleOutageResponse[]>(ADMIN_SERVICE.schedule_outages_list, skipSpinnerOptions());
  }

  public createScheduleOutage(outageData:ScheduleOutageNew): Observable<ScheduleOutageResponse> {
    return this.http.post<ScheduleOutageResponse>(ADMIN_SERVICE.create_schedule_outage, outageData, skipSpinnerOptions());
  }

  public updateScheduleOutage(outage_id:number, outageData:ScheduleOutageUpdate): Observable<ScheduleOutageResponse> {
    return this.http.put<ScheduleOutageResponse>(`${ADMIN_SERVICE.update_schedule_outage}${outage_id}`, outageData, skipSpinnerOptions());
  }

  public deleteScheduleOutage(outage_id:number, outageData:ScheduleOutageDelete): Observable<ScheduleOutageResponse> {
    return this.http.put<ScheduleOutageResponse>(`${ADMIN_SERVICE.delete_schedule_outage}${outage_id}`, outageData, skipSpinnerOptions());
  }
}
